import { QueuedMessage } from "./types";

export class LeakyBucket {
	queuedMessages: QueuedMessage[] = [];
	messageInterval: NodeJS.Timeout;
	ns: string;

	constructor(time: number, ns: string) {
		this.ns = ns;
		this.messageInterval = setInterval(this.run, time);
	}
	run = () => {
		const message = this.queuedMessages.shift();
		if (message) {
			self.postMessage({ ...message, _ns: this.ns });
		}
	};

	add = (message: QueuedMessage) => {
		this.queuedMessages.push(message);
	};

	stop = () => {
		clearInterval(this.messageInterval);
	};
}